export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "API Url": "API Url",
        "Bazowy adres API Ipresso.": "Ipresso API base URL.",
        "CUSTOMER_KEY": "CUSTOMER_KEY",
        "Dane dostępowe integracji marketing automation.": "Marketing automation integration credentials.",
        "Dane są nie prawidłowe.": "Data are invalid.",
        "Dane są prawidłowe.": "Data are valid.",
        "Hasło": "Password",
        "Hasło konta integracyjnego.": "Integration account password.",
        "Ipresso": "Ipresso",
        "Klucz klienta nadany przez Ipresso.": "Customer key provided by Ipresso.",
        "Login": "Login",
        "Login konta integracyjnego.": "Integration account login.",
        "Paleta kolorów": "Color palette",
        "Pokaż hasło": "Show password",
        "Pokaż klucz klienta": "Show customer key",
        "Połączenie Ipresso": "Ipresso connection",
        "Przetestuj poprawność danych": "Test data validity",
        "Synchronizacja kontaktów": "Contact synchronization",
        "Synchronizacja ustawień": "Settings synchronization",
        "Synchronizacja zgód kontaktów": "Contact consent synchronization",
        "System": "System",
        "Ukryj hasło": "Hide password",
        "Ukryj klucz klienta": "Hide customer key",
        "Ustawienia": "Settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Zadanie synchronizacji kontaktów Ipresso zostało rozpoczęte.": "Ipresso contact synchronization task has started.",
        "Zadanie synchronizacji ustawień Ipresso zostało rozpoczęte.": "Ipresso settings synchronization task has started.",
        "Zadanie synchronizacji zgód kontaktów Ipresso zostało rozpoczęte.": "Ipresso contact consent synchronization task has started.",
        "Zapisz": "Save"
    }
};
